import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api, { fmtDate } from "../../lib/api";
import { Loading, PageHeader, StatusPill, EmptyState } from "../../components/Shared";

const FILTERS = [
  { v: "open", label: "Open" },
  { v: "requested", label: "Requested" },
  { v: "acknowledged", label: "Acknowledged" },
  { v: "arranging", label: "Arranging" },
  { v: "scheduled", label: "Scheduled" },
  { v: "in_progress", label: "In progress" },
  { v: "completed", label: "Completed" },
  { v: "cancelled", label: "Cancelled" },
  { v: "", label: "All" },
];

export default function ServiceRequests() {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("open");
  useEffect(() => {
    setRows(null);
    api.get(`/admin/service-requests${status ? `?status=${status}` : ""}`)
      .then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [status]);
  return (
    <div data-testid="admin-service-requests">
      <PageHeader title="Service Requests" sub="Every family request — acknowledge, arrange, schedule, assign and complete." />
      <div className="mb-4 flex flex-wrap gap-2" data-testid="request-filters">
        {FILTERS.map((f) => (
          <button key={f.v} onClick={() => setStatus(f.v)} data-testid={`filter-${f.v || "all"}`}
            className={`rounded-full px-3.5 py-1.5 text-xs font-bold transition-colors ${status === f.v ? "bg-emerald-900 text-white" : "border border-stone-200 bg-white text-stone-600 hover:border-emerald-700"}`}>
            {f.label}
          </button>
        ))}
      </div>
      {!rows ? <Loading /> : rows.length === 0 ? (
        <EmptyState title="No requests" body="No service requests match this filter." />
      ) : (
        <div className="space-y-2.5">
          {rows.map((r) => (
            <Link key={r.id} to={`/app/admin/requests/${r.id}`} data-testid={`sr-row-${r.id}`}
              className="p1-card flex items-center justify-between gap-3 p-4 transition-shadow hover:shadow-md">
              <div className="min-w-0">
                <p className="flex flex-wrap items-center gap-2 font-heading font-semibold text-stone-900">
                  {r.type}
                  {r.urgency === "urgent" && <span className="rounded bg-red-100 px-1.5 py-0.5 text-[10px] font-bold text-red-700">URGENT</span>}
                </p>
                <p className="text-xs text-stone-500">
                  {r.family_name}{r.parent_name ? ` · ${r.parent_name}` : ""} · raised {fmtDate(r.created_at)}
                </p>
                {(r.provider_name || r.scheduled_at) && (
                  <p className="mt-0.5 text-xs text-stone-400">
                    {r.provider_name && <>Provider: <strong className="text-stone-600">{r.provider_name}</strong> </>}
                    {r.scheduled_at && <>· {fmtDate(r.scheduled_at)}</>}
                  </p>
                )}
              </div>
              <div className="flex shrink-0 items-center gap-2">
                <StatusPill status={r.status} />
                <ChevronRight className="h-4 w-4 text-stone-300" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
